import React from 'react';
import style from "./index.module.css";
import searchIcon from "../../assets/icons/search_1.svg";
import onlineIcon from "../../assets/icons/online.svg";
import auditIcon from "../../assets/icons/audit.svg";
import cpAuditIcon from "../../assets/icons/cpAudit.svg";
import {Button} from "antd";
import {showWarning} from "../../utils";
import {useNavigate} from 'react-router-dom';

const CertificateNavModule = () => {
    const navigate = useNavigate();
    return (
        <div>
            <div>
                <Button className={style.additionalButtonEachBtn}
                        type="primary" onClick={() => {
                    showWarning("敬请期待!~");
                }}>申请方需知</Button>
                <Button className={style.additionalButtonEachBtn}
                        type="primary" onClick={() => {
                    navigate('/certificateNotice', {state: {subPath: 'c2'}})
                }}>认证流程</Button>
                <Button className={style.additionalButtonEachBtn}
                        type="primary" onClick={() => {
                    navigate('/certificateNotice', {state: {subPath: 'c3'}})
                }}>认证收费</Button>
                <Button className={style.additionalButtonEachBtn}
                        type="primary" onClick={() => {
                    showWarning("敬请期待!~");
                }}>在线申请认证</Button>
            </div>

            <div className={style.additionalIconBlock}>
                <div className={style.eachItem} onClick={() => {
                    // showWarning("敬请期待!~");
                    navigate('/certSearch')
                }}>
                    <img width={50} height={50} src={searchIcon} alt=""/>
                    <div style={{marginTop: 15}}>证书查询</div>
                </div>

                <div className={style.eachItem} onClick={() => {
                    showWarning("敬请期待!~");
                }}>
                    <img width={50} height={50} src={onlineIcon} alt=""/>
                    <div style={{marginTop: 15}}>在线办公</div>
                </div>

                <div className={style.eachItem} onClick={() => {
                    showWarning("敬请期待!~");
                }}>
                    <img width={50} height={50} src={auditIcon} alt=""/>
                    <div style={{marginTop: 15}}>审核员专区</div>
                </div>

                <div className={style.eachItem} onClick={() => {
                    showWarning("敬请期待!~");
                }}>
                    <img width={50} height={50} src={cpAuditIcon} alt=""/>
                    <div style={{marginTop: 15}}>人员资质查询</div>
                </div>
            </div>
        </div>
    );
};

export default CertificateNavModule;